;(function ($) {


    window.popup = {
        pageStatus: {
            isOpen:false,
            isKefuAutoOpened: false,
            autoOpenTimer: null, //自动打开窗口计时器
        },

        //40秒后自动弹出
        setAtuoOpen: function () {
            var _this = this;
            var isCookieKefuOpened = common.getCookie('ispopUpOpened');
            if (!isCookieKefuOpened) { //如果打开过则24小时内不再自动打开
                _this.pageStatus.autoOpenTimer = setTimeout(function () {
                    //打开弹窗
                    _this.open();
                },  window.cateData.kefuOpenTime * 1000);
            }
        },

        //pop弹出
        open: function(){
            //打开弹窗
            if(this.pageStatus.isOpen){
                return;
            }
            $('.timer-pop-up-wap-box').removeClass('hide');
            $('.timer-pop-up-wap-box').addClass('ani-form-bottom');
            this.pageStatus.isOpen = true;
            // gioTrackAction.gio_base('popupImp', {'popupType_var': '人工弹窗'});
        },

        //清除计时器，如何页面不需要这个弹窗可以调用这个方法
        setDontOpen: function () {
            var _this = this;
            window.clearTimeout(_this.pageStatus.autoOpenTimer);
        },

        //设置24小时不再打开
        setPopUpCookie: function () {
            event.stopPropagation();
            $('.timer-pop-up-wap-box').addClass('hide');
            $('.timer-pop-up-wap-box').removeClass('ani-form-bottom');
            this.pageStatus.isOpen = false;
            var _this = this;
            //如果窗口打开过则设置一个24小时的cookie不再触发自动打开 并取消当前页面的40秒自动打开计时器
            //清除计时器
            clearTimeout(_this.pageStatus.autoOpenTimer);
            //设置cookie
            var isCookieKefuOpened = common.getCookie('ispopUpOpened');
            if(!isCookieKefuOpened){ //如果cookie不存在再设置
                common.setCookie('ispopUpOpened','true',1);
            }
        },

        jumpSales: function(type){
            this.setPopUpCookie();
            if (type == 'wap'){
                solution_wap_msg.ProjectConsultingDialog('click_further_Intentions');
            }else {
                solution_msg.ProjectConsultingDialog('click_further_Intentions');
            }
        },


        init: function () {
            this.setAtuoOpen();
        }
    };

    setTimeout(function () {
        // if(getUserInfo.getUserTeam() == 1){
        //     // popup.init();
        // }
    }, 2000);

})(jQuery);

